import api from "../../../../api/axios";

const BASE = "/postosorigem";
const DEFAULT_LIST_LIMIT = 5000;

function mapRow(row = {}) {
  return {
    ...row,
    motivo: row?.posto_origem ?? row?.motivo ?? "",
  };
}

export async function listarPostosOrigem({
  q = "",
  ativo,
  limit = DEFAULT_LIST_LIMIT,
  offset = 0,
} = {}) {
  const { data } = await api.get(`${BASE}/listar`, { params: { q, ativo, limit, offset } });
  const rows = Array.isArray(data?.data) ?data.data.map(mapRow) : [];
  return {
    rows,
    meta: data?.meta || { limit, offset },
  };
}

export async function cadastrarPostoOrigem(payload) {
  const { data } = await api.post(`${BASE}/cadastrar`, {
    posto_origem: payload?.motivo ?? "",
  });
  return data;
}

export async function editarPostoOrigem(id, payload) {
  const { data } = await api.put(`${BASE}/editar/${id}`, {
    posto_origem: payload?.motivo ?? "",
  });
  return data;
}

export async function alterarStatusPostoOrigem(id, ativo) {
  const { data } = await api.patch(`${BASE}/alterar-ativo/${id}`, {
    ativo: Number(ativo) ?1 : 0,
  });
  return data;
}

export async function excluirPostoOrigem(id) {
  const { data } = await api.delete(`${BASE}/excluir/${id}`);
  return data;
}
